module.exports = __webpack_public_path__ + "static/media/angular.4c732369.svg";